import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { dashRoutes } from "./dashboard.routes";
import { authRoutes } from "./auth.routes";
import { customerRoutes } from "./customer.routes";
import { apolloClient } from "@/apollo";
import { VERIFY_EMAIL } from "@/queries/common/mutation";
import store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  ...dashRoutes,
  ...authRoutes,
  ...customerRoutes,
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/Error.vue"),
  },
  {
    path: "/verify-email",
    name: "verify-email",
    async beforeEnter(to, from, next) {
      console.log(to);

      const { email, verifyEmailToken } = to.query;
      console.log(to.query);

      if (!email && !verifyEmailToken) {
        next("/");
        return;
      }
      store.commit("loadersModule/toggleGlobalLoader", true);
      try {
        const {
          data: { verifyEmail },
          errors,
        } = await apolloClient.mutate({
          mutation: VERIFY_EMAIL,
          variables: {
            email,
            verifyEmailToken,
          },
        });
        if (verifyEmail) {
          store.commit(
            "alertModule/success",
            "Account is verified successfuly."
          );
        }
      } catch (error) {
        store.commit(
          "alertModule/error",
          "Verification has been expired! please verify again."
        );
      }
      store.commit("loadersModule/toggleGlobalLoader", false);
      next("/");
    },
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name === "menu-dish") {
      return;
    }
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },
});

export default router;
